import React from "react"
import Button from "../Atoms/Button"
import styled from "styled-components"
import i18n from "i18next"
import Colors from "../res/styles/Colors"

const Container = styled.div`
    position: relative;
`
const Selector = styled.select`
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
`

function LanguageSelector() {
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng)
    }

    const getLanguage = (lng) => {
        switch (lng) {
            case "it-IT":
                return "ITALIANO"
            case "en-EN":
                return "ENGLISH"
            case "fr-FR":
                return "FRANÇAIS"
            default:
                return "ENGLISH"
        }
    }

    return (
        <Button
            borderColor={Colors.peach}
            textColor={Colors.peach}
            onClick={() => console.log("Language Clicked")}
        >
            <Container>
                {getLanguage(i18n.language)}
                <Selector
                    onChange={(e) => changeLanguage(e.currentTarget.value)}
                    value={i18n.language}
                >
                    <option value="it-IT">ITALIANO</option>
                    <option value="en-EN">ENGLISH</option>
                    <option value="fr-FR">FRANÇAIS</option>
                </Selector>
            </Container>
        </Button>
    )
}

export default LanguageSelector
